module.exports = __webpack_public_path__ + "img/16.a55401eb.png";